export const getRangeWithStep = (range: number[], length: number) => {
    const res = [range[0]];
    const step = range[1] / (length - 1);
    for (let i = 1; i <= length - 1; i ++) {
        res.push(i * step);
    }
    return res;
};
